import { __awaiter } from "tslib";
import initOptimizelyVanillaUsercontext from '../initOptimizelyVanillaUsercontext';
/**
 * Returns am OpnimizelyDecision object for the provided flag key
 * See: https://docs.developers.optimizely.com/full-stack/v4.0/docs/optimizelydecision-javascript
 *
 * @param  {string} flagKey - Flag key.
 * @param  {object} customAttributes - Custom user attributes (locale, optOut, qaMode are applied automatically)
 * @returns {OptimizelyDecision}
 */
const decideOptimizelyVanilla = (flagKey, customAttributes = {}) => __awaiter(void 0, void 0, void 0, function* () {
    var _a;
    if (!window.optimizelyVanillaUsercontext) {
        yield initOptimizelyVanillaUsercontext();
    }
    Object.keys(customAttributes).forEach((key) => {
        var _a;
        (_a = window === null || window === void 0 ? void 0 : window.optimizelyVanillaUsercontext) === null || _a === void 0 ? void 0 : _a.setAttribute(key, customAttributes[key]);
    });
    const decision = yield ((_a = window === null || window === void 0 ? void 0 : window.optimizelyVanillaUsercontext) === null || _a === void 0 ? void 0 : _a.decide(flagKey));
    return decision;
});
export default decideOptimizelyVanilla;
//# sourceMappingURL=decideOptimizelyVanilla.js.map